import { render, staticRenderFns } from "./DriversPeriodAvailableEditForm.vue?vue&type=template&id=61203cf5&scoped=true&"
import script from "./DriversPeriodAvailableEditForm.vue?vue&type=script&lang=js&"
export * from "./DriversPeriodAvailableEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DriversPeriodAvailableEditForm.vue?vue&type=style&index=0&id=61203cf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61203cf5",
  null
  
)

export default component.exports